import type {Pointer, PS} from '@wix/document-services-types'

export default {
    beforeAdd(ps: PS, compToAddPointer: Pointer, containerPointer: Pointer, compDefinitionPrototype) {
        compDefinitionPrototype.componentType = 'wysiwyg.viewer.components.WPhoto'
        compDefinitionPrototype.props.displayMode = 'fill'
    }
}
